import Bouncer from 'formbouncerjs';
import contactValidationMessages from "./contactValidationMessages";

export function edroneNewsletter(selector) {
    if (!selector) return;

    window._edrone = window._edrone || {};
    const newsletterForm = document.querySelector(selector);

    const lang = document.documentElement.lang;
    const messages = (lang !== 'en-GB' || lang !== 'en' || lang !== 'en-US') ? contactValidationMessages[lang] : {};

    const validate = new Bouncer(selector, {
        disableSubmit: true,
        messages
    });


    document.addEventListener('bouncerFormValid', function (e) {
        if (!e.target.matches(selector)) return;
        const form = e.target;
        const errorBox = form.querySelector('.newsletter-form__error');

        _edrone.customer_tags = form.dataset.tags || 'homepage';
        _edrone.email = form.querySelector('#email').value;
        _edrone.first_name = form.querySelector('#firstName').value;
        _edrone.action_type = 'subscribe';
        if (typeof _edrone.init === 'function') {
            _edrone.init();
            errorBox.style.display = 'none';
            form.reset();
        } else {
            errorBox.style.display = 'block';
        }

    });


}